<template>
    <section class="init_box" style="background-color:white;">
        <el-row>
            <el-col :span="24" style="margin-top: 15px;margin-left: 15px;">
                <!-- <el-button class="btn" type="success" @click="">编辑界面</el-button> -->
                <!-- <el-button class="btn" type="success" @click="">资料上传</el-button> -->
                <!-- <el-button class="btn" type="info" @click="">使用记录</el-button> -->
                <!-- <el-button class="btn" type="primary" v-if="btnRole.indexOf('13')!=-1" @click="toWeiBao">维保申请</el-button>
                <el-button class="btn" type="primary" v-if="btnRole.indexOf('19')!=-1" @click="toBaoFei">报废申请</el-button>
                <el-button class="btn" type="primary" v-if="btnRole.indexOf('11')!=-1" @click="toCheck">检定申请</el-button> -->
                <span v-if="btnShow.indexOf('fail') == -1" class="btn">
                    <el-button class="btn" type="primary" size="small" @click="clickComit">保存</el-button>
                    <el-button class="btn" type="primary" size="small" @click="clickComitAndBack">保存并返回</el-button>
                </span>
                <el-button class="btn" v-if="btnShow.indexOf('fail') != -1" type="primary" size="small"
                    @click="clickRecomit">提交</el-button>
                <el-button class="btn" type="info" size="small" @click="returnDeviceinfo"
                    style="margin-left: 10px">返回</el-button>
                <span style="color: red;float:left;margin-left: 25px;margin-top: 12px;">注：前方为*的为必填项</span>

            </el-col>
        </el-row>
        <el-row style="margin-top:15px;margin-left:10px">
            <el-form :model="formLabel" ref="formLabel" :rules="checkform" style="margin-left:10px " label-width="auto">
                <el-col :span="10">
                    <el-form-item v-for="(item, index) in formLableLeft" :key="item.key" :label="item.key"
                        :prop="'' + item.model + ''"
                        v-if="(item.type == 1 || item.type == 3 || item.type == 6) && (item.value == 'zcmc' || item.value == 'sccj'
                            || item.value == 'ccbh' || item.value == 'clfw' || item.value == 'sbxh' || item.value == 'bgr' || item.value == 'jdlx' || item.value == 'cljd')"
                        :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                        <el-input class="input" v-if="item.type == 1" :placeholder="item.placeholder" name="item.value"
                            v-model="formLabel[item.model]"></el-input>
                        <el-input :rows="1" type="textarea" class="input" v-if="item.type == 6"
                            :placeholder="item.placeholder" name="item.value"
                            v-model="formLabel[item.model]"></el-input>

                    </el-form-item>
                    <el-form-item :key="item.prop" :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.type == 2) && (item.value == 'jdlx' || item.value == 'yjfl')"
                        :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">

                        <el-select filterable v-model="formLabel[item.model]"
                            v-if="item.type == 2 && item.value == 'jdlx'" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select" @change="jdlxChange">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                        <el-select filterable v-model="formLabel[item.model]" v-else style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select" @change="yjflChange">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :key="item.prop" :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.type == 2) && (item.value == 'ssdw')">
                        <el-select filterable v-model="formLabel[item.model]"
                            v-if="item.type == 2 && item.value == 'ssdw'" style="height:32px;text-align:left"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>

                    </el-form-item>
                    <el-form-item :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.type == 5) && (item.value == 'sydw')"
                        :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                        <!-- <el-select filterable v-model="formLabel[item.model]" v-if="item.type == 5" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select> -->
                        <el-cascader v-model="formLabel[item.model]" style="height:32px" :options="options"
                            :props="props" class="input select" :show-all-levels="true" filterable
                            :placeholder="item.placeholder"></el-cascader>
                    </el-form-item>
                    <el-form-item :key="item.model" :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.type == 4) && (item.value == 'cgrq')"
                        :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">

                        <el-date-picker v-if="item.type == 4" class="input select" name="item.value" style="width:90%"
                            :placeholder="item.placeholder" value-format="yyyy-MM-dd" v-model="formLabel[item.model]"
                            type="date">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :key="item.placeholder" :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.value == 'sl')"
                        :rules="{ type: 'number', message: '此处应填写数字', trigger: 'change' }">
                        <el-input size="small" class="input" v-model.number="formLabel[item.model]"
                            :placeholder="item.placeholder" auto-complete="off"
                            v-if="item.type == 1 && (item.value == 'sl')" name="item.value"></el-input>
                    </el-form-item>
                    <el-form-item :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.type == 1) && (item.value == 'jdzq')"
                        :rules="formLabel['jdlx'] == 3 ? [] : [{ required: true, message: '此处为必填项', trigger: 'change' }, { pattern: /^[0-9]+$/, message: '请输入数字周期（单位：月），无需检定请改选类型' }]">
                        <el-input size="small" class="input" v-model.number="formLabel[item.model]"
                            :placeholder="item.placeholder" auto-complete="off"
                            v-if="item.type == 1 && (item.value == 'jdzq')" name="item.value"></el-input>
                    </el-form-item>
                    <el-form-item :key="item.label" :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.value == 'yz' || item.value == 'jd' || item.value == 'ljzj' || item.value == 'zjl')"
                        :rules="[{ message: '请填写两位小数或整数', trigger: 'blur' }, { pattern: /^\d{0,9}(.\d{1,3})?$/, message: '请输入两位小数或整数' }]">
                        <el-input size="small" class="input" v-model="formLabel[item.model]"
                            :placeholder="item.placeholder" auto-complete="off"
                            v-if="item.type == 1 && (item.value == 'yz' || item.value == 'jd' || item.value == 'ljzj' || item.value == 'zjl')"
                            name="item.value" :precision="2" clearable></el-input>
                    </el-form-item>
                    <el-form-item :key="item.id" :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.value != 'zcmc' || item.value != 'sccj' || item.value != 'ccbh' ||
                            item.value != 'sbxh' || item.value != 'bgr' || item.value != 'clfw' || item.value != 'cgrq' ||
                            item.value != 'sydw' || item.value != 'cljd' || item.value != 'jdlx' || item.value != 'yz' ||
                            item.value != 'jd' || item.value != 'ljzj' || item.value != 'zjl' || item.value != 'jdzq' || item.value != 'ssdw')">
                        <el-input size="small" v-if="item.type == 1 && (item.value != 'glbh' && item.value != 'sl')"
                            class="input" :placeholder="item.placeholder" name="item.value"
                            v-model="formLabel[item.model]"></el-input>
                        <el-input size="small" v-if="item.type == 1 && item.value == 'glbh'" style="width:80%"
                            class="input" :placeholder="item.placeholder" name="item.value"
                            v-model="formLabel[item.model]" disabled></el-input>
                        <el-button type="primary" v-if="item.value == 'glbh'" size="small"
                            @click="shenhe()">审核</el-button>

                        <el-select v-model="formLabel[item.model]" filterable
                            v-else-if="item.type == 2 && item.value != 'zyfl' && item.value != 'yjfl' && item.value != 'ejfl' && item.value != 'sydw' && item.value != 'jdlx' && item.value != 'xmfl'"
                            style="height:32px" :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                        <el-select filterable v-model="formLabel[item.model]"
                            v-else-if="item.type == 2 && item.value == 'zyfl'" @change="zyflChange" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                        <el-select filterable v-model="formLabel[item.model]"
                            v-else-if="item.type == 2 && item.value == 'xmfl'" @change="xmflChange" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                        <el-select filterable v-model="formLabel[item.model]"
                            v-else-if="item.type == 2 && item.value == 'yjfl'" @change="yjflChange" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                        <el-select filterable v-model="formLabel[item.model]"
                            v-else-if="item.type == 2 && item.value == 'ejfl'" @change="ejflChange" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                        <el-date-picker v-else-if="item.type == 4" class="input select" name="item.value"
                            style="width:90%" :placeholder="item.placeholder" value-format="yyyy-MM-dd"
                            v-model="formLabel[item.model]" type="date">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item v-for="(item, index) in formLableRight" :key="item.key" :label="item.key"
                        :prop="'' + item.model + ''"
                        v-if="(item.type == 1 || item.type == 3 || item.type == 6) && (item.value == 'zcmc' || item.value == 'sccj'
                            || item.value == 'ccbh' || item.value == 'sbxh' || item.value == 'clfw' || item.value == 'bgr' || item.value == 'jdlx' || item.value == 'cljd')"
                        :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                        <el-input size="small" class="input" v-if="item.type == 1" :placeholder="item.placeholder"
                            name="item.value" v-model="formLabel[item.model]"></el-input>
                        <el-input :rows="1" type="textarea" class="input" v-if="item.type == 6"
                            :placeholder="item.placeholder" name="item.value" v-model="formLabel[item.model]"
                            style="margin-top:-20px"></el-input>

                    </el-form-item>
                    <el-form-item :key="item.prop" :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.type == 2) && (item.value == 'jdlx' || item.value == 'yjfl')"
                        :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                        <el-select filterable v-model="formLabel[item.model]"
                            v-if="item.type == 2 && item.value == 'jdlx'" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select" @change="jdlxChange">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                        <el-select filterable v-model="formLabel[item.model]" v-else style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select" @change="yjflChange">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :key="item.prop" :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.type == 2) && (item.value == 'ssdw')">
                        <el-select filterable v-model="formLabel[item.model]"
                            v-if="item.type == 2 && item.value == 'ssdw'" style="height:32px;text-align:left"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>

                    </el-form-item>
                    <el-form-item :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.type == 5) && (item.value == 'sydw')"
                        :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                        <!-- <el-select filterable v-model="formLabel[item.model]" v-if="item.type == 5" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select> -->
                        <el-cascader v-model="item.model" style="height:32px" :options="options" :props="props"
                            class="input select" :show-all-levels="true" filterable
                            :placeholder="item.placeholder"></el-cascader>
                    </el-form-item>
                    <el-form-item :key="item.placeholder" :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.type == 4) && (item.value == 'cgrq')"
                        :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                        <el-date-picker v-if="item.type == 4" class="input select" name="item.value" style="width:90%"
                            :placeholder="item.placeholder" value-format="yyyy-MM-dd" v-model="formLabel[item.model]"
                            type="date">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :key="item.model" :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.value == 'sl')"
                        :rules="{ type: 'number', message: '此处应填写数字', trigger: 'change' }">
                        <el-input size="small" class="input" v-model.number="formLabel[item.model]"
                            :placeholder="item.placeholder" auto-complete="off"
                            v-if="item.type == 1 && (item.value == 'sl' || item.value == 'jdzq')"
                            name="item.value"></el-input>
                    </el-form-item>
                    <el-form-item :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.type == 1) && (item.value == 'jdzq')"
                        :rules="formLabel['jdlx'] == 3 ? [] : [{ required: true, message: '此处为必填项', trigger: 'change' }, { pattern: /^[0-9]+$/, message: '请输入数字周期（单位：月），无需检定请改选类型' }]">
                        <el-input size="small" class="input" v-model.number="formLabel[item.model]"
                            :placeholder="item.placeholder" auto-complete="off"
                            v-if="item.type == 1 && (item.value == 'jdzq')" name="item.value"></el-input>
                    </el-form-item>
                    <el-form-item :key="item.label" :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.value == 'yz' || item.value == 'jd' || item.value == 'ljzj' || item.value == 'zjl')"
                        :rules="[{ message: '请填写两位小数或整数', trigger: 'blur' }, { pattern: /^\d{0,9}(.\d{1,3})?$/, message: '请输入两位小数或整数' }]">
                        <el-input size="small" class="input" v-model="formLabel[item.model]"
                            :placeholder="item.placeholder" auto-complete="off"
                            v-if="item.type == 1 && (item.value == 'yz' || item.value == 'jd' || item.value == 'ljzj' || item.value == 'zjl')"
                            name="item.value" :precision="2" clearable></el-input>
                    </el-form-item>
                    <el-form-item :key="item.id" :label="item.key" :prop="'' + item.model + ''"
                        v-else-if="(item.value != 'zcmc' || item.value != 'clfw' || item.value != 'sccj' || item.value != 'ccbh' ||
                            item.value != 'sbxh' || item.value != 'bgr' || item.value != 'cgrq' ||
                            item.value != 'sydw' || item.value != 'cljd' || item.value != 'jdlx' || item.value != 'yz'
                            || item.value != 'jd' || item.value != 'ljzj' || item.value != 'zjl' || item.value != 'jdzq' || item.value != 'ssdw')">
                        <el-input size="small" v-if="item.type == 1 && (item.value != 'glbh' && item.value != 'sl')"
                            class="input" :placeholder="item.placeholder" name="item.value"
                            v-model="formLabel[item.model]"></el-input>
                        <el-input size="small" v-if="item.type == 1 && item.value == 'glbh'" style="width:80%"
                            class="input" :placeholder="item.placeholder" name="item.value"
                            v-model="formLabel[item.model]" disabled></el-input>
                        <el-button type="primary" v-if="item.value == 'glbh'" size="small"
                            @click="shenhe()">审核</el-button>

                        <el-select v-model="formLabel[item.model]" filterable
                            v-else-if="item.type == 2 && item.value != 'zyfl' && item.value != 'yjfl' && item.value != 'ejfl' && item.value != 'xmfl'"
                            style="height:32px" :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                        <el-select v-model="formLabel[item.model]" filterable
                            v-else-if="item.type == 2 && item.value == 'zyfl'" @change="zyflChange" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                        <el-select filterable v-model="formLabel[item.model]"
                            v-else-if="item.type == 2 && item.value == 'xmfl'" @change="xmflChange" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                        <el-select v-model="formLabel[item.model]" filterable
                            v-else-if="item.type == 2 && item.value == 'yjfl'" @change="yjflChange" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                        <el-select v-model="formLabel[item.model]" filterable
                            v-else-if="item.type == 2 && item.value == 'ejfl'" @change="ejflChange" style="height:32px"
                            :placeholder="item.placeholder" name="item.value" class="input select">
                            <el-option v-for="items in selectData[item.value]" :key="items.value" :label="items.label"
                                :value="items.value"></el-option>
                        </el-select>
                        <el-date-picker v-else-if="item.type == 4" class="input select" name="item.value"
                            style="width:90%" :placeholder="item.placeholder" value-format="yyyy-MM-dd"
                            v-model="formLabel[item.model]" type="date">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="20">
                    <el-collapse v-model="activeName" style="padding-bottom: 10px;">
                        <el-collapse-item name="other" v-if="isShows">
                            <template slot="title" class="collapse-title">
                                <span style="margin-left:10px">资产信息 </span>
                            </template>
                            <el-row style="margin-top:15px;margin-left:10px">
                                <el-col :span="12">
                                    <el-form-item v-for="(item, index) in formLableLeftDetail" :key="item.key"
                                        :label="item.key">
                                        <el-input size="small" v-if="item.type == 1" class="input"
                                            :placeholder="item.placeholder" name="item.value"
                                            v-model="formLabel[item.model]">
                                        </el-input>
                                        <el-select v-model="formLabel[item.model]" v-else-if="item.type == 2"
                                            style="height:32px" name="item.value" class="input select"
                                            :placeholder="item.placeholder">
                                            <el-option v-for="items in selectData[item.value]" :key="items.value"
                                                :label="items.label" :value="items.value"></el-option>
                                        </el-select>
                                        <el-date-picker v-else-if="item.type == 4" class="input select"
                                            name="item.value" value-format="yyyy-MM-dd" v-model="formLabel[item.model]"
                                            type="date" :placeholder="item.placeholder">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item v-for="(item, index) in formLableRightDetail" :key="item.key"
                                        :label="item.key">
                                        <el-input size="small" v-if="item.type == 1" class="input"
                                            :placeholder="item.placeholder" name="item.value"
                                            v-model="formLabel[item.model]">
                                        </el-input>
                                        <el-select v-model="formLabel[item.model]" v-else-if="item.type == 2"
                                            style="height:32px" name="item.value" class="input select"
                                            :placeholder="item.placeholder">
                                            <el-option v-for="items in selectData[item.value]" :key="items.value"
                                                :label="items.label" :value="items.value"></el-option>
                                        </el-select>
                                        <el-date-picker v-else-if="item.type == 4" class="input select"
                                            name="item.value" value-format="yyyy-MM-dd" v-model="formLabel[item.model]"
                                            type="date" :placeholder="item.placeholder">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="relevant">
                            <template slot="title">
                                <span style="margin-left:10px">设备资料</span>
                            </template>
                            <el-row>
                                <el-col :span="23">
                                    <el-table style="margin-left:30px" :data="deviceDocData">
                                        <el-table-column type="index" label="序号" width="70"></el-table-column>
                                        <el-table-column prop="name" label="资料名称" width="200"></el-table-column>
                                        <el-table-column prop="type" label="资料类型" width="200"></el-table-column>
                                        <el-table-column prop="createUser" label="上传人" width="170"></el-table-column>
                                        <el-table-column prop="createTime" label="上传日期" width="150"
                                            :formatter="formateTime"></el-table-column>
                                        <el-table-column prop="remark" label="备注" width="200"></el-table-column>
                                        <el-table-column label="操作">
                                            <template slot-scope="scope">
                                                <el-link :underline="false" v-if="btnRole.indexOf('135') != -1"
                                                    style="color: #4095E5;text-decoration: none;"
                                                    @click="updateDocBtn(scope.row)">编辑 </el-link>
                                                <el-link :underline="false" v-if="btnRole.indexOf('133') != -1"
                                                    style="color: #4095E5;text-decoration: none;"
                                                    @click="deleteDeviceDoc(scope.row)">删除 </el-link>
                                                <el-link :underline="false"
                                                    style="color: #4095E5;text-decoration: none;"
                                                    @click="onlineView(scope.row)">预览 </el-link>
                                                <el-link :underline="false"
                                                    style="color: #4095E5;text-decoration: none;"
                                                    @click="downloading(scope.row)">下载 </el-link>
                                            </template>
                                        </el-table-column>
                                        <el-table-column :render-header="renderHeader" width="70"></el-table-column>
                                    </el-table>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item name="annex">
                            <template slot="title">
                                <span style="margin-left:10px">设备附件({{ annexNum }})</span>
                            </template>
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="24">
                                        <el-table :data="annexData" stripe style="margin-left: 10px;">
                                            <el-table-column type="index" label="序号" width="80">
                                            </el-table-column>
                                            <el-table-column prop="zcmc" label="名称" show-overflow-tooltip>
                                            </el-table-column>
                                            <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
                                            </el-table-column>
                                            <el-table-column prop="ccbh" label="出厂编号" show-overflow-tooltip>
                                            </el-table-column>
                                            <el-table-column prop="cgrq" label="采购日期" show-overflow-tooltip>
                                            </el-table-column>
                                            <!-- <el-table-column prop="sl" label="数量"  show-overflow-tooltip>
                                            </el-table-column>
                                            <el-table-column prop="dw" label="单位"  show-overflow-tooltip>
                                            </el-table-column> -->
                                            <el-table-column prop="jdlx" label="检定类型" show-overflow-tooltip>
                                                <template slot-scope="scope">
                                                    <span v-if="scope.row.jdlx == 0">检定</span>
                                                    <span v-if="scope.row.jdlx == 1">核查</span>
                                                    <span v-if="scope.row.jdlx == 2">校准</span>
                                                    <span v-if="scope.row.jdlx == 3">不检定/校准</span>
                                                </template>
                                            </el-table-column>
                                            <!-- <el-table-column prop="jdzq" label="检定周期"  show-overflow-tooltip>
                                            </el-table-column> -->
                                            <el-table-column prop="clfw" label="测量范围" show-overflow-tooltip>
                                            </el-table-column>
                                            <el-table-column prop="cljd" label="测量精度" show-overflow-tooltip>
                                            </el-table-column>
                                            <!-- <el-table-column prop="lrrq" label="上传日期"
                                                show-overflow-tooltip :formatter="formateTime">
                                            </el-table-column> -->
                                            <el-table-column prop="bz" label="备注" show-overflow-tooltip>
                                            </el-table-column>
                                            <el-table-column label="操作">
                                                <template slot-scope="scope">
                                                    <el-link :underline="false"
                                                        style="color: #4095E5;text-decoration: none;"
                                                        v-if="btnRole.indexOf('141') != -1"
                                                        @click="clickAnnexUpdate(scope.row)">编辑 </el-link>
                                                    <el-link :underline="false"
                                                        style="color: #4095E5;text-decoration: none;"
                                                        v-if="btnRole.indexOf('142') != -1"
                                                        @click="deleteDeviceAnnex(scope.row)">删除 </el-link>
                                                    <el-link :underline="false"
                                                        style="color: #4095E5;text-decoration: none;"
                                                        v-if="btnRole.indexOf('142') != -1"
                                                        @click="clickAnnexDetail(scope.row)">详情 </el-link>
                                                </template>
                                            </el-table-column>
                                            <el-table-column width="175" :render-header="insertAnnex"></el-table-column>
                                            <!-- <el-table-column :render-header="insertAnnexExcel"></el-table-column> -->
                                        </el-table>
                                    </el-col>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
        <el-dialog title="添加资料" :close-on-click-modal="false" :close-on-press-escape="false"
            :visible.sync="insertdialog" width="30%">
            <el-form ref="insertForm" :model="insertForm" label-width="80px">
                <el-form-item label="资料名称" required>
                    <el-input v-model="insertForm.name" placeholder="请输入资料名称"></el-input>
                </el-form-item>
                <el-form-item label="资料类型" required>
                    <el-select v-model="insertForm.type" placeholder="请选择资料类型" style="width:100%">
                        <el-option v-for="item in insertType" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择资料" required>
                    <el-upload class="upload-demo" action="string" style="align:left" :on-preview="handlePreview"
                        :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1"
                        :on-exceed="handleExceed" :file-list="fileList" :auto-upload="false" :http-request="uploadFile"
                        :on-change="handleChange">
                        <el-button size="small" type="primary" @click="clearFileList">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" autosize v-model="insertForm.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="uploadFiles">立即创建</el-button>
                    <el-button @click="insertdialog = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="修改资料信息" :close-on-click-modal="false" :close-on-press-escape="false"
            :visible.sync="updateDocdialog" width="30%">
            <el-form ref="updateDocData" :model="updateDocData" label-width="80px">
                <el-form-item label="资料名称" required>
                    <el-input v-model="updateDocData.name" placeholder="请输入资料名称"></el-input>
                </el-form-item>
                <el-form-item label="资料类型" required>
                    <el-select v-model="updateDocData.type" placeholder="请选择资料类型" style="width:100%">
                        <el-option v-for="item in insertType" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" autosize v-model="updateDocData.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="updateDoc">修改</el-button>
                    <el-button @click="updateDocdialog = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
            <FilePreview ref="filePreview" />
        </el-dialog>
        <!-- 添加附件 -->
        <el-dialog title="添加附件" :close-on-click-modal="false" @close="exitInsert" :close-on-press-escape="false"
            :visible.sync="insertAnnexDialog" width="30%">
            <el-form ref="annexForm" :model="annexForm" label-width="auto">
                <el-form-item label="附件名称" prop="zcmc" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-input v-model="annexForm.zcmc" placeholder="请输入附件名称"></el-input>
                </el-form-item>
                <el-form-item label="出厂编号" prop="ccbh"
                    :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }]">
                    <el-input v-model="annexForm.ccbh" placeholder="请输入出厂编号"></el-input>
                </el-form-item>
                <el-form-item label="采购日期" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="cgrq">
                    <el-date-picker class="input select" name="item.value" style="width: 100%;" placeholder="请选择采购日期"
                        value-format="yyyy-MM-dd" v-model="annexForm.cgrq" type="date">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="检定类型" prop="jdlx"
                    :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }]">
                    <el-select filterable v-model="annexForm.jdlx" style="height:32px;width: 100%;"
                        placeholder="请选择检定类型" class="select" @change="jdlxChangeAnnex">
                        <el-option v-for="items in selectData['jdlx']" :key="items.value" :label="items.label"
                            :value="items.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="检定周期" :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }, { pattern: /^\d+$/, message: '检定周期只能输入数字', trigger: 'blur' }]" prop="jdzq">
                    <el-input v-model="annexForm.jdzq" placeholder="请输入检定周期" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="测量范围" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="clfw">
                    <el-input v-model="annexForm.clfw" placeholder="请输入测量范围"></el-input>
                </el-form-item>
                <el-form-item label="测量精度" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="cljd">
                    <el-input v-model="annexForm.cljd" placeholder="请输入测量精度"></el-input>
                </el-form-item>
                <!-- <el-form-item label="数量" prop="sl"
                    :rules="[{ required: true, message: '此处为必填项', trigger: 'change' }, { pattern: /^(([0-9]*))$/, message: '请输入数字' }]">
                    <el-input v-model="annexForm.sl" placeholder="请输入附件数量"></el-input>
                </el-form-item>
                <el-form-item label="单位" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="dw">
                    <el-input v-model="annexForm.dw" placeholder="请输入单位"></el-input>
                </el-form-item> -->
                <el-form-item label="备注" prop="bz">
                    <el-input type="textarea" autosize v-model="annexForm.bz" placeholder="请输入备注"></el-input>
                </el-form-item>

            </el-form>
            <el-button type="primary" @click="insertAnnexs">立即创建</el-button>
            <el-button @click="exitInsert">取消</el-button>
        </el-dialog>
        <!-- 修改附件 -->
        <el-dialog title="修改附件" :close-on-click-modal="false" :close-on-press-escape="false"
            :visible.sync="updateAnnexDialog" width="30%">
            <el-form ref="annexUpdateForm" :model="annexUpdateForm" label-width="auto">
                <el-form-item label="附件名称" prop="zcmc" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }">
                    <el-input v-model="annexUpdateForm.zcmc" placeholder="请输入附件名称"></el-input>
                </el-form-item>
                <el-form-item label="管理编号" prop="glbh">
                    <el-input v-model="annexUpdateForm.glbh" readonly placeholder="请输入附件编号"></el-input>
                </el-form-item>
                <el-form-item label="出厂编号" prop="ccbh"
                    :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }]">
                    <el-input v-model="annexUpdateForm.ccbh" placeholder="请输入出厂编号"></el-input>
                </el-form-item>
                <el-form-item label="采购日期" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="cgrq">
                    <el-date-picker class="input select" name="item.value" style="width: 100%;" placeholder="请选择采购日期"
                        value-format="yyyy-MM-dd" v-model="annexUpdateForm.cgrq" type="date">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="检定类型" prop="jdlx"
                    :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }]">
                    <el-select filterable v-model="annexUpdateForm.jdlx" style="height:32px;width: 100%;"
                        placeholder="请选择检定类型" class="select" @change="jdlxChangeAnnex">
                        <el-option v-for="items in selectData['jdlx']" :key="items.value" :label="items.label"
                            :value="items.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="检定周期" :rules="[{ required: true, message: '此处为必填项', trigger: 'blur' }, { pattern: /^\d+$/, message: '检定周期只能输入数字', trigger: 'blur' }]" prop="jdzq">
                    <el-input v-model="annexUpdateForm.jdzq" placeholder="请输入检定周期" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="测量范围" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="clfw">
                    <el-input v-model="annexUpdateForm.clfw" placeholder="请输入测量范围"></el-input>
                </el-form-item>
                <el-form-item label="测量精度" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="cljd">
                    <el-input v-model="annexUpdateForm.cljd" placeholder="请输入测量精度"></el-input>
                </el-form-item>
                <!-- <el-form-item label="数量" prop="sl"
                    :rules="[{ required: true, message: '此处为必填项', trigger: 'change' }, { pattern: /^(([0-9]*))$/, message: '请输入数字' }]">
                    <el-input v-model="annexUpdateForm.sl" placeholder="请输入附件数量"></el-input>
                </el-form-item>
                <el-form-item label="单位" :rules="{ required: true, message: '此处为必填项', trigger: 'blur' }" prop="dw">
                    <el-input v-model="annexUpdateForm.dw" placeholder="请输入单位"></el-input>
                </el-form-item> -->
                <el-form-item label="备注" prop="bz">
                    <el-input type="textarea" autosize v-model="annexUpdateForm.bz" placeholder="请输入备注"></el-input>
                </el-form-item>

            </el-form>
            <el-button type="primary" @click="updateAnnexComit">确定</el-button>
            <el-button @click="updateAnnexDialog = false">取消</el-button>
        </el-dialog>
        <!-- 批量导入附件弹窗 -->
        <el-dialog title="批量导入附件" :close-on-click-modal="false" :close-on-press-escape="false"
            :visible.sync="importExcelDialog" width="350px" @close='closeExcelDialog'>
            <el-form ref="excelForm" :model="excelForm" label-width="80px">
                <el-form-item label="导入附件" prop="deviceExcel" :rules="{ required: true }">
                    <!-- <el-upload class="upload-demo" action="" :before-upload="beforeUpload"
						:show-file-list="false" :http-request="uploadFile"> -->
                    <el-upload class="upload-demo" action="string" style="align:left" :on-preview="handlePreviewExcel"
                        :on-remove="handleRemoveExcel" :before-remove="beforeRemoveExcel" multiple :limit="1"
                        :on-exceed="handleExceedExcel" :file-list="fileList" :auto-upload="false"
                        :http-request="uploadFile" :on-change="handleChangeExcel" :before-upload="beforeUploadExcel"
                        accept=".xlsx">
                        <el-button size="mini" type="info" plain :loading="uploadBool">
                            {{ uploadBool ? '文件上传中...' : '导入附件' }}
                        </el-button>
                    </el-upload>
                    <!-- <imgUpload type="2" :limit="1" @fileListChange="fileListChange"/> -->
                    <div class="upload__tips">仅支持上传.xlsx文件</div>
                    <el-button type="text" @click="download">下载附件导入模板</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="clickUpload">上传文件</el-button>
                    <el-button @click="importExcelDialog = false">取消</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
        <!-- 附件详情 -->
        <el-dialog title="附件详情" :close-on-click-modal="false" :close-on-press-escape="false"
            :visible.sync="annexDetailDialog" width="50%">
            <annex-detail ref="annexDetailShow" :annexId="deviceAnnexId"></annex-detail>
        </el-dialog>
    </section>
</template>
<script>
// import DeviceinfoCard from './Deviceinfo_card.vue';
import FilePreview from '../../components/preview/FilePreview.vue'
import {
    selectAllstatus, updateAnnex,
    selectAllDeviceType, getDeviceType,
    selectAllDeviceTypeBypid, deleteAnnex,
    selectByGlbh, selectAllCompany,
    GLAdd, selectDeviceinfoByid, reComitDeviceinfoByid,
    updateDeviceinfoByid, insertAnnex, selectAnnex, selectDeviceFenlei, insertAnnexsExcel,
    uploadAttachments, selectDeviceinfoDoc, deleteById, updateById, getBase, treeCompanyByCode
} from '../../api/api';
import AnnexDetail from './components/AnnexDetail.vue';
export default {
    components: { FilePreview, AnnexDetail },
    data() {
        return {
            annexNum: 0,
            activeName: 'other',
            deviceCarddialog: false,
            insertdialog: false,
            docxdialog: false,
            importExcelDialog: false,
            annexDetailDialog: false,
            btnShow: sessionStorage.getItem("examineResult"),
            insertAnnexDialog: false,
            updateAnnexDialog: false,
            inject: ["reload"],
            formAddLabel: [],
            formLabel: {},
            checkform: {
                zcmc: { required: true, trigger: 'blur' },
                zcss: { required: true, trigger: 'blur' },
            },
            deviceDocData: [],
            formLableLeft: [],
            formLableRight: [],
            formLableLeftDetail: [],
            formLableRightDetail: [],
            selectData: {
                yjfl: [],
                sydw: [],
                zyfl: [],
                xmfl: [],
                ejfl: [],
                ssdw: [{
                    label: '甘肃路桥建设集团有限公司',
                    value: '甘肃路桥建设集团有限公司',
                }, {
                    label: '甘肃智通科技工程检测咨询有限公司',
                    value: '甘肃智通科技工程检测咨询有限公司',
                }, {
                    label: '甘肃省交通建设质量安全造价中心',
                    value: '甘肃省交通建设质量安全造价中心',
                }, {
                    label: '其他',
                    value: '其他',
                }],
                sbzt: [],
                jszk: [
                    {
                        label: '一类',
                        value: '一类',
                    }, {
                        label: '二类',
                        value: '二类',
                    }, {
                        label: '三类',
                        value: '三类',
                    }, {
                        label: '四类',
                        value: '四类',
                    }],
                glfs: [],
                jdlx: [{
                    label: '检定',
                    value: 0,
                }, {
                    label: '设备核查',
                    value: 1,
                }, {
                    label: '校准',
                    value: 2,
                }, {
                    label: '不检定/校准',
                    value: 3,
                }],
                zclx: [{
                    label: '固定资产',
                    value: '固定资产',
                }, {
                    label: '低值易耗品',
                    value: '低值易耗品',
                }],
                zcssfl: [{
                    label: '自购',
                    value: '自购',
                }, {
                    label: '租赁',
                    value: '租赁',
                }, {
                    label: '其他',
                    value: '其他',
                }],
            },
            previewTitle: '',
            deviceTypeData: [],
            zyData: [],
            insertForm: {},
            insertType: [{
                value: '设备整体图片',
                label: '设备整体图片'
            }, {
                value: '设备铭牌',
                label: '设备铭牌'
            }, {
                value: '设备说明书',
                label: '设备说明书'
            }, {
                value: '合格证',
                label: '合格证'
            }, {
                value: '装箱清单',
                label: '装箱清单'
            }, {
                value: '购置发票',
                label: '购置发票'
            }, {
                value: '设备验收记录',
                label: '设备验收记录'
            }, {
                value: '设备安装调试记录',
                label: '设备安装调试记录'
            }, {
                value: '仪器设备申请单',
                label: '仪器设备申请单'
            }, {
                value: '使用授权书',
                label: '使用授权书'
            }, {
                value: '设备安全操作规程',
                label: '设备安全操作规程'
            }, {
                value: '调拨单',
                label: '调拨单'
            }, {
                value: '固定资产卡片',
                label: '固定资产卡片'
            }, {
                value: '试验检测仪器设备技术档案',
                label: '试验检测仪器设备技术档案'
            }, {
                value: '设备购置合同',
                label: '设备购置合同'
            }, {
                value: '设备交底',
                label: '设备交底'
            }, {
                value: '保修卡',
                label: '保修卡'
            }, {
                value: '设备操作规程',
                label: '设备操作规程'
            }, {
                value: '技术交底',
                label: '技术交底'
            }, {
                value: '安全交底',
                label: '安全交底'
            }, {
                value: '其他',
                label: '其他'
            }],
            fileList: [],
            insertFormData: "",
            updateDocdialog: false,
            updateDocData: {},
            propType: "",//存放column.prop的字符串值
            btnRole: [],
            reload: false,
            statusData: [],
            projectTypeData: [],
            isShows: false,
            props: {
                label: 'companyName',
                value: 'companyCode',
                children: 'zcompany',
                expandTrigger: 'click',
                emitPath: false
            },
            options: [],
            annexForm: {},
            annexData: [],
            annexUpdateForm: [],
            pid: "",
            deviceinfoData: [],
            excelForm: {
                deviceExcel: ''
            },
            deviceAnnexList: [],
            uploadBool: false,
            loading: false,
            loadingText: "",
            loadingInstance: null,
            deviceAnnexDetail: [],
            deviceAnnexCheckDetail: [],
            deviceAnnexId: "",
        }
    },
    beforeRouteUpdate(to, from, next) {
    },
    methods: {

        getFormAddLabel() {
            let formAllLabel = JSON.parse(sessionStorage.getItem('deviceinfoLable'));
            let deviceUpdateDatas = JSON.parse(sessionStorage.getItem('deviceUpdate'));
            let deviceUpdateData
            let deviceId
            if (deviceUpdateDatas.length == 1) {
                deviceId = JSON.parse(sessionStorage.getItem('deviceUpdate'))[0].id
            } else {
                deviceId = JSON.parse(sessionStorage.getItem('deviceUpdate')).id
            }

            let _this = this
            selectDeviceinfoByid(deviceId).then(datas => {
                let { data, status, message } = datas
                if (status == 200) {
                    deviceUpdateData = data
                    this.deviceinfoData = data
                    if (deviceUpdateData.length != 1) {
                        selectAllstatus().then(datas => {
                            let { status, data } = datas
                            if (status == 200) {
                                for (var i = 0; i < data.length; i++) {
                                    if (data[i].statusType == "设备台账") {
                                        if (_this.statusData[i].statusName == deviceUpdateData["sbzt"]) {
                                            _this.$set(_this.formLabel, "sbzt", _this.statusData[i].id)
                                        }
                                    }
                                }
                            }
                        })
                    }
                    // this.formAddLabel=JSON.parse(sessionStorage.getItem('deviceinfoLable'));
                    for (var i = 0; i < formAllLabel.length; i++) {
                        if (formAllLabel[i].showPostion == 3 || formAllLabel[i].showPostion == 5 || formAllLabel[i].showPostion == 6) {
                            if (formAllLabel[i].isShow != 0) {
                                _this.formAddLabel.push(formAllLabel[i]);
                                if (deviceUpdateData.length == 1) {
                                    _this.$set(_this.formLabel, formAllLabel[i].prop, deviceUpdateData[0][formAllLabel[i].prop])
                                } else {
                                    _this.$set(_this.formLabel, formAllLabel[i].prop, deviceUpdateData[formAllLabel[i].prop])
                                }


                            }
                        }
                    }
                    for (var i = 0; i < _this.formAddLabel.length; i++) {

                        if (_this.formAddLabel[i].isOther) {
                            if (_this.formAddLabel[i].orders % 2 != 0) {
                                //将输入框的lable和value存在数组里面，在页面遍历数组显示输入框
                                if (_this.formAddLabel[i].inputtype == 1) {
                                    _this.formLableLeftDetail.push({ name: _this.formAddLabel[i].prop, key: _this.formAddLabel[i].label, value: _this.formAddLabel[i].prop, model: _this.formAddLabel[i].prop, placeholder: '请输入' + _this.formAddLabel[i].label, type: _this.formAddLabel[i].inputtype })
                                } else {
                                    _this.formLableLeftDetail.push({ name: _this.formAddLabel[i].prop, key: _this.formAddLabel[i].label, value: _this.formAddLabel[i].prop, model: _this.formAddLabel[i].prop, placeholder: '请选择' + _this.formAddLabel[i].label, type: _this.formAddLabel[i].inputtype })
                                }
                            } else {
                                if (_this.formAddLabel[i].inputtype == 1) {
                                    _this.formLableRightDetail.push({ name: _this.formAddLabel[i].prop, key: _this.formAddLabel[i].label, value: _this.formAddLabel[i].prop, model: _this.formAddLabel[i].prop, placeholder: '请输入' + _this.formAddLabel[i].label, type: _this.formAddLabel[i].inputtype })

                                } else {
                                    _this.formLableRightDetail.push({ name: _this.formAddLabel[i].prop, key: _this.formAddLabel[i].label, value: _this.formAddLabel[i].prop, model: _this.formAddLabel[i].prop, placeholder: '请选择' + _this.formAddLabel[i].label, type: _this.formAddLabel[i].inputtype })

                                }
                            }
                        } else {
                            // debugger
                            if (_this.formAddLabel[i].orders % 2 != 0) {
                                if (_this.formAddLabel[i].inputtype == 1) {
                                    //将输入框的lable和value存在数组里面，在页面遍历数组显示输入框
                                    _this.formLableRight.push({ name: _this.formAddLabel[i].prop, key: _this.formAddLabel[i].label, value: _this.formAddLabel[i].prop, model: _this.formAddLabel[i].prop, placeholder: '请输入' + _this.formAddLabel[i].label, type: _this.formAddLabel[i].inputtype })

                                } else {
                                    _this.formLableRight.push({ name: _this.formAddLabel[i].prop, key: _this.formAddLabel[i].label, value: _this.formAddLabel[i].prop, model: _this.formAddLabel[i].prop, placeholder: '请选择' + _this.formAddLabel[i].label, type: _this.formAddLabel[i].inputtype })
                                }
                            } else {
                                if (_this.formAddLabel[i].inputtype == 1) {
                                    //将输入框的lable和value存在数组里面，在页面遍历数组显示输入框
                                    _this.formLableLeft.push({ name: _this.formAddLabel[i].prop, key: _this.formAddLabel[i].label, value: _this.formAddLabel[i].prop, model: _this.formAddLabel[i].prop, placeholder: '请输入' + _this.formAddLabel[i].label, type: _this.formAddLabel[i].inputtype })

                                } else {
                                    //将输入框的lable和value存在数组里面，在页面遍历数组显示输入框
                                    _this.formLableLeft.push({ name: _this.formAddLabel[i].prop, key: _this.formAddLabel[i].label, value: _this.formAddLabel[i].prop, model: _this.formAddLabel[i].prop, placeholder: '请选择' + _this.formAddLabel[i].label, type: _this.formAddLabel[i].inputtype })

                                }
                            }

                        }

                    }
                }
            })

            let userinfo = JSON.parse(localStorage.getItem("user"))
            this.btnRole = userinfo.role.menuId.split(",")
            if ((userinfo.role.menuId).indexOf("187") != -1 || userinfo.userRole == 1) {
                this.activeName = 'other'
                this.isShows = true
            } else {
                this.activeName = 'relevant'
                this.isShows = false
            }
        },
        //动态给下拉框添加值
        getSelectData() {
            const _this = this
            //查找设备状态
            selectAllstatus().then(datas => {
                let { status, data } = datas
                _this.statusData = data
                if (status == 200) {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].statusType == "设备台账") {
                            _this.selectData["sbzt"].push({ label: data[i].statusName, value: data[i].id })
                        }
                    }
                }
            })
            //查找单位
            // selectAllCompany().then(datas => {
            //     let { status, data } = datas
            //     let userinfo = JSON.parse(localStorage.getItem("user"))
            //     let isShowAll = false
            //     if (userinfo.companyCode == "G065" || userinfo.companyCode == "G") {
            //         isShowAll = true
            //     } else {
            //         isShowAll = false
            //     }
            //     if (status == 200) {
            //         for (var i = 0; i < data.length; i++) {
            //             if (isShowAll) {
            //                 _this.selectData["sydw"].push({ label: data[i].companyName, value: data[i].companyCode })
            //             } else {
            //                 if (data[i].companyCode == userinfo.companyCode) {
            //                     _this.selectData["sydw"].push({ label: data[i].companyName, value: data[i].companyCode })
            //                 }
            //             }

            //         }

            //     }
            // })

            //查找设备类型
            selectAllDeviceType().then(datas => {
                let { status, data } = datas
                if (status == 200) {
                    let deviceUpdateData = JSON.parse(sessionStorage.getItem('deviceUpdate'));
                    _this.deviceTypeData = data
                    for (var i = 0; i < data.length; i++) {

                        if (data[i].pid == "P") {
                            _this.selectData["yjfl"].push({ label: data[i].deviceTypeName, value: data[i].id })
                        }

                        // if(data[i].pid==deviceUpdateData[0]['yjfl']){
                        //     _this.selectData["ejfl"].push({ label: data[i].deviceTypeName, value: data[i].id })
                        // }

                    }


                }
            })
            //查找专业
            let _params = {
                level: 2
            }
            let deviceUpdateData = JSON.parse(sessionStorage.getItem('deviceUpdate'));
            if (deviceUpdateData.length == 1) {
                if (deviceUpdateData[0]['yjfl'].indexOf("P0001") != -1) {
                    _this.selectData["zyfl"].push({ label: "/", value: "/" })
                } else {
                    selectDeviceFenlei(_params).then(resultData => {
                        let { data, status, message } = resultData;
                        for (var i = 0; i < data.length; i++) {
                            _this.selectData["zyfl"].push({ label: data[i].deviceTypeName, value: data[i].code })
                        }
                    })
                }
            } else {
                if (deviceUpdateData['yjfl'].indexOf("P0001") != -1) {
                    _this.selectData["zyfl"].push({ label: "/", value: "/" })
                } else {
                    selectDeviceFenlei(_params).then(resultData => {
                        let { data, status, message } = resultData;
                        for (var i = 0; i < data.length; i++) {
                            _this.selectData["zyfl"].push({ label: data[i].deviceTypeName, value: data[i].code })
                        }
                    })
                }
            }
            // selectAllMajorType().then(datas => {
            //     let { status, data } = datas
            //     if (status == 200) {
            //         let deviceUpdateData = JSON.parse(sessionStorage.getItem('deviceUpdate'));
            //         _this.zyData = data
            //         if (deviceUpdateData.length == 1) {
            //             if (deviceUpdateData[0]['yjfl'].indexOf("P0001") != -1) {
            //                 _this.selectData["zyfl"].push({ label: "/", value: "/" })
            //             } else {
            //                 for (var i = 0; i < data.length; i++) {
            //                     _this.selectData["zyfl"].push({ label: data[i].name, value: data[i].id })
            //                 }
            //             }
            //         } else {
            //             if (deviceUpdateData['yjfl'].indexOf("P0001") != -1) {
            //                 _this.selectData["zyfl"].push({ label: "/", value: "/" })
            //             } else {
            //                 for (var i = 0; i < data.length; i++) {
            //                     _this.selectData["zyfl"].push({ label: data[i].name, value: data[i].id })
            //                 }
            //             }
            //         }
            //     }
            // })
            //  查找项目
            // debugger
            // if(this.deviceData["zyfl"]!=null&&this.deviceData["zyfl"].length>1){
            //     selectAllProjectTypeByMid(this.deviceData["zyfl"]).then(datas=>{

            //         let {data,status,message} = datas
            //     })
            // }

        },

        selectCompany() {
            let _parmas = {
                userId: JSON.parse(localStorage.getItem("user")).userId
            }
            treeCompanyByCode(_parmas).then(datas => {
                let { status, message, data } = datas;
                if (status == 400) {
                    this.$message({
                        message: message,
                        type: "error"
                    });
                } else if (status == 200) {
                    this.options = this.getTreeData(data);
                    // console.log(this.options)
                } else {
                    this.$message({
                        message: "请求错误",
                        type: "error"
                    });
                }
            });
        },
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].zcompany.length > 0) {
                    // children不为空时继续调用该方法
                    this.getTreeData(data[i].zcompany);

                } else {
                    // 最后一级没有数据将children变成undefined
                    data[i].zcompany = undefined;
                }
            }
            return data;
        },
        //专业分类下拉框改变
        zyflChange(val) {
            let _this = this
            _this.selectData['xmfl'] = []
            _this.selectData['ejfl'] = []
            _this.formLabel["xmfl"] = ""
            _this.formLabel["ejfl"] = ""
            // let pid;
            for (var i = 0; i < this.deviceTypeData.length; i++) {
                if (val == this.deviceTypeData[i].code && this.deviceTypeData[i].level == 2) {
                    this.pid = this.deviceTypeData[i].id
                }
            }
            let _params = {
                level: 3,
                pid: this.pid
            }
            selectDeviceFenlei(_params).then(resultData => {
                let { data, status, message } = resultData
                if (status == 200) {
                    for (var i = 0; i < data.length; i++) {
                        _this.selectData['xmfl'].push({ label: data[i].deviceTypeName, value: data[i].code, })
                    }
                }
            })
            // for (var i = 0; i < this.zyData.length; i++) {
            //     if (val == this.zyData[i].id) {
            //         const mid = this.zyData[i].id
            //         selectAllProjectTypeByMids(mid).then(datas => {
            //             let { status, data } = datas
            //             if (status == 200) {
            //                 _this.projectTypeData = data
            //                 for (var i = 0; i < data.length; i++) {
            //                     _this.selectData['xmfl'].push({ label: data[i].name, value: data[i].id, })
            //                 }
            //             }
            //         })
            //     }
            // }
        },
        // 项目分类下拉框改变
        xmflChange(val) {
            const _this = this
            _this.selectData['ejfl'] = []
            _this.formLabel["ejfl"] = ""
            let device
            let pid;
            for (var i = 0; i < this.deviceTypeData.length; i++) {
                if (val == this.deviceTypeData[i].code && this.deviceTypeData[i].level == 3 && this.deviceTypeData[i].pid == this.pid) {
                    pid = this.deviceTypeData[i].id
                }
            }
            let _params = {
                level: 4,
                pid: pid
            }
            selectDeviceFenlei(_params).then(resultData => {
                let { data, status, message } = resultData;
                if (status == 200) {
                    for (var i = 0; i < data.length; i++) {
                        _this.selectData['ejfl'].push({ label: data[i].deviceTypeName, value: data[i].id })
                    }
                }
            })
            // for (var i = 0; i < _this.projectTypeData.length; i++) {
            //     if (val == _this.projectTypeData[i].id) {
            //         device = _this.projectTypeData[i].device
            //     }
            // }
            // let devices = device.split(",")
            // for (var i = 0; i < devices.length; i++) {
            //     for (var j = 0; j < this.deviceTypeData.length; j++) {
            //         if (this.deviceTypeData[j].deviceTypeName == devices[i]) {
            //             _this.selectData['ejfl'].push({ label: devices[i], value: this.deviceTypeData[j].id })
            //         }
            //     }
            // }
        },
        //一级分类下拉框改变
        yjflChange(val) {
            const _this = this
            _this.selectData['ejfl'] = []
            _this.selectData['zyfl'] = []
            _this.selectData['xmfl'] = []
            if (val == "P0001" || val == "办公设备") {
                _this.formLabel["zyfl"] = "/"
                _this.formLabel["xmfl"] = "/"
                _this.formLabel["ejfl"] = ""
                _this.formLabel["glfs"] = ""
                _this.selectData['glfs'] = []
                for (var i = 0; i < _this.deviceTypeData.length; i++) {
                    if (val == _this.deviceTypeData[i].deviceTypeCode) {
                        const deviceTypeCode = _this.deviceTypeData[i].deviceTypeCode
                        selectAllDeviceTypeBypid(deviceTypeCode).then(datas => {
                            let { status, data } = datas
                            if (status == 200) {
                                _this.selectData['ejfl'] = []
                                for (var i = 0; i < data.length; i++) {
                                    _this.selectData['ejfl'].push({ label: data[i].deviceTypeName, value: data[i].id, })
                                }
                            }
                        })
                        return
                    }
                }
            } else {
                _this.formLabel["zyfl"] = ""
                _this.formLabel["xmfl"] = ""
                _this.formLabel["ejfl"] = ""
                _this.selectData['glfs'].push({
                    label: 'I',
                    value: 'I',
                }, {
                    label: 'II-1',
                    value: 'II-1',
                }, {
                    label: 'II-2',
                    value: 'II-2',
                }, {
                    label: 'II-3',
                    value: 'II-3',
                }, {
                    label: 'III',
                    value: 'III',
                })
                let _params = {
                    level: 2
                }
                selectDeviceFenlei(_params).then(resultData => {
                    let { data, status, message } = resultData;
                    if (status == 200) {
                        for (var i = 0; i < data.length; i++) {
                            _this.selectData["zyfl"].push({ label: data[i].deviceTypeName, value: data[i].code })
                        }
                    }
                })
                // for (var i = 0; i < this.zyData.length; i++) {
                //     _this.selectData["zyfl"].push({ label: this.zyData[i].name, value: this.zyData[i].id })
                // }
            }

        },
        ejflChange(val) {
            const _this = this
            _this.formLabel["glbh"] = ""
            for (var i = 0; i < this.deviceTypeData.length; i++) {
                if (val == this.deviceTypeData[i].id) {

                    if (this.deviceTypeData[i].glbhqz != null && this.deviceTypeData[i].glbhqz.length > 0) {
                        let _params = {
                            glbhqz: this.deviceTypeData[i].glbhqz
                        }
                        GLAdd(_params).then(datas => {
                            _this.formLabel["glbh"] = datas
                        })
                    }
                    this.formLabel["glfs"] = this.deviceTypeData[i].glfs
                }
            }
        },
        // 检定类型下拉框改变
        jdlxChange(val) {
            if (val == 3) {
                this.formLabel["jdzq"] = "/"
            } else {
                this.formLabel["jdzq"] = ""
            }
        },
        // 附件检定类型改变
        jdlxChangeAnnex(val) {
            if (val == 3) {
                if (this.annexForm["jdlx"] != null) {
                    this.annexForm["jdzq"] = "/"
                } else {
                    this.annexUpdateForm["jdzq"] = "/"
                }
            }
        },
        // 页面加载设备分类下拉框
        onloadEjflSelect() {
            const _this = this
            let val = ""
            let mid = ""
            let xmfl = ""
            let deviceId = ""
            let deviceupdates = JSON.parse(sessionStorage.getItem("deviceUpdate"))
            if (deviceupdates.length == 1) {
                deviceId = JSON.parse(sessionStorage.getItem('deviceUpdate'))[0].id
            } else {
                deviceId = JSON.parse(sessionStorage.getItem('deviceUpdate')).id
            }

            selectDeviceinfoByid(deviceId).then(datas => {
                let { data, status, message } = datas
                if (status == 200) {
                    val = data.yjfl
                    mid = data.zyfl
                    xmfl = data.xmfl
                    if (val.indexOf("P0002") != -1 || val == "检测设备") {
                        _this.selectData['glfs'].push({
                            label: 'I',
                            value: 'I',
                        }, {
                            label: 'II-1',
                            value: 'II-1',
                        }, {
                            label: 'II-2',
                            value: 'II-2',
                        }, {
                            label: 'II-3',
                            value: 'II-3',
                        }, {
                            label: 'III',
                            value: 'III',
                        })
                        _this.selectData['ejfl'] = []
                        let device
                        let pid
                        let _parma = {
                            level: 2
                        }
                        selectDeviceFenlei(_parma).then(resultData => {
                            let { data, status, message } = resultData;
                            if (status == 200) {

                                for (var i = 0; i < resultData.data.length; i++) {
                                    if (resultData.data[i].code == mid && mid != "" && mid != null) {
                                        pid = resultData.data[i].id
                                    }
                                }
                                let _params = {
                                    level: 3,
                                    pid: pid
                                }
                                if (mid != null && mid != "") {
                                    selectDeviceFenlei(_params).then(resultData => {
                                        let { data, status, message } = resultData;
                                        if (status == 200) {
                                            let pid;
                                            for (var i = 0; i < data.length; i++) {
                                                if (data[i].code == xmfl && xmfl != "" && xmfl != null) {
                                                    pid = data[i].id
                                                }
                                                _this.selectData['xmfl'].push({ label: data[i].deviceTypeName, value: data[i].code, })
                                            }
                                            let params = {
                                                level: 4,
                                                pid: pid
                                            }
                                            if (xmfl != null && xmfl != "") {
                                                selectDeviceFenlei(params).then(resultDatas => {
                                                    if (resultDatas.status == 200) {
                                                        for (var i = 0; i < resultDatas.data.length; i++) {
                                                            _this.selectData['ejfl'].push({ label: resultDatas.data[i].deviceTypeName, value: resultDatas.data[i].id })
                                                        }
                                                    }
                                                })
                                            }

                                        }
                                    })
                                }

                            }
                        })

                        // selectAllProjectTypeByMids(mid).then(datas => {
                        //     let { status, data } = datas
                        //     if (status == 200) {
                        //         _this.projectTypeData = data
                        //         for (var i = 0; i < data.length; i++) {
                        //             _this.selectData['xmfl'].push({ label: data[i].name, value: data[i].id, })
                        //         }
                        //         for (var i = 0; i < _this.projectTypeData.length; i++) {
                        //             if ((_this.projectTypeData[i].id).indexOf(xmfl) != -1) {
                        //                 device = _this.projectTypeData[i].device
                        //             }
                        //         }
                        //         const devices = device.split(",")
                        //         selectAllDeviceType().then(datas => {
                        //             let { status, data } = datas
                        //             if (status == 200) {
                        //                 for (var i = 0; i < devices.length; i++) {
                        //                     for (var j = 0; j < data.length; j++) {
                        //                         if (data[j].deviceTypeName == devices[i]) {
                        //                             _this.selectData['ejfl'].push({ label: devices[i], value: data[j].id })
                        //                         }
                        //                     }
                        //                 }
                        //             }
                        //         })

                        //     }
                        // })
                    } else {
                        getDeviceType().then(datas => {
                            let { status, data } = datas
                            if (status == 200) {
                                for (var i = 0; i < data.length; i++) {
                                    // _this.selectData["yjfl"].push({ label: data[i].deviceTypeName, value: data[i].id })
                                    _this.selectData['ejfl'].push({ label: data[i].deviceTypeName, value: data[i].id, })
                                }
                            }
                        })

                    }
                }
            })



        },
        // 点击保存
        clickComit(val) {
            if (this.formLabel['zcmc'] == null || this.formLabel['zcmc'] == "") {
                this.$message({
                    message: "资产名称不能为空",
                    type: 'warning'
                });
            } else {
                if (JSON.parse(sessionStorage.getItem('deviceUpdate')).length == 1) {
                    this.$set(this.formLabel, "id", JSON.parse(sessionStorage.getItem('deviceUpdate'))[0]['id'])
                } else {
                    this.$set(this.formLabel, "id", JSON.parse(sessionStorage.getItem('deviceUpdate'))['id'])
                }

                let _params = {
                    parameter: JSON.stringify(this.formLabel),
                    userId: JSON.parse(localStorage.getItem("user")).userId
                }
                updateDeviceinfoByid(_params).then(datas => {
                    let { status, message } = datas;
                    if (status == 200) {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        })
                        // setTimeout(() => {
                        //     // let val = {
                        //     //     "path": "/DeviceInfo",
                        //     //     "name": "设备信息",
                        //     //     "title": "设备信息"
                        //     // };
                        //     // debugger

                        //     //添加路由跳转至查看设备
                        //     this.$router.push({
                        //         path: "DeviceInfo",

                        //     });
                        //     // this.$store.commit("pushtags", val)
                        //     let item = {
                        //         "path": "/deviceinfoUpdate",
                        //         "name": "设备信息-修改设备"
                        //     }
                        //     this.closeTab(item);
                        // }, 2000);
                    } else {
                        this.$message({
                            message: message,
                            type: 'error'
                        })
                    }

                })
            }

        },
        // 点击提交
        clickRecomit() {
            if (this.formLabel['zcmc'] == null || this.formLabel['zcmc'] == "") {
                this.$message({
                    message: "资产名称不能为空",
                    type: 'warning'
                });
            } else {
                if (JSON.parse(sessionStorage.getItem('deviceUpdate')).length == 1) {
                    this.$set(this.formLabel, "id", JSON.parse(sessionStorage.getItem('deviceUpdate'))[0]['id'])
                } else {
                    this.$set(this.formLabel, "id", JSON.parse(sessionStorage.getItem('deviceUpdate'))['id'])
                }
                let _params = {
                    parameter: JSON.stringify(this.formLabel),
                    userId: JSON.parse(localStorage.getItem("user")).userId
                }
                reComitDeviceinfoByid(_params).then(datas => {
                    let { status, message } = datas;
                    if (status == 200) {
                        this.$message({
                            message: '提交成功，请等待审核通过',
                            type: 'success'
                        })
                        setTimeout(() => {
                            this.$router.go(-1)
                        }, 1500)
                    } else {
                        this.$message({
                            message: message || '提交失败',
                            type: 'error'
                        })
                    }

                })
            }
        },
        //点击返回按钮返回至上一次点击时的页面
        returnDeviceinfo() {
            // let val = {
            //     "path": "/DeviceInfo",
            //     "name": "设备信息"
            // };
            //添加路由跳转至查看设备
            this.reload = false
            // this.$router.push({
            //     path: "DeviceInfo",
            // });
            this.$router.go(-1)
            // this.$store.commit("pushtags", val)
        },
        // 管理编号审核
        shenhe() {
            let glbh = this.formLabel['glbh']
            if (glbh != "") {
                selectByGlbh(glbh).then(datas => {
                    let { status } = datas
                    if (status == 200) {
                        this.$message({
                            message: '管理编号重复',
                            type: 'error'
                        })
                    } else if (status == 400) {
                        this.$message({
                            message: '审核通过',
                            type: 'success'
                        })
                    }
                })
            } else {
                this.$message({
                    message: '请输入管理编号',
                    type: 'error'
                })
            }
            // console.log("zglbhbh", glbh)
        },
        // 查找设备资料
        getDeviceDoc() {
            let deviceDatas = JSON.parse(sessionStorage.getItem('deviceUpdate'))
            let deviceData;
            if (deviceDatas.length == 1) {
                deviceData = deviceDatas[0]
            } else {
                deviceData = deviceDatas
            }
            let _params = {
                deviceId: deviceData.id,
                // uuid:deviceData.sbxh+"_"+deviceData.sccj+"_"+deviceData.glbh.substr(0,8)
            }
            let _this = this
            selectDeviceinfoDoc(_params).then(datas => {
                let { status, data, message } = datas
                if (status == 200) {
                    _this.deviceDocData = []
                    for (var i = 0; i < data.length; i++) {
                        _this.deviceDocData.push(data[i])
                    }

                }
            })
        },
        // 资料添加按钮
        renderHeader() {
            if (this.btnRole.indexOf('134') != -1) {
                return (
                    <div  >
                        <el-button type="primary" size="small" on-click={() => this.clickInsert()}>添加</el-button>
                    </div>
                )
            }

        },
        // 附件添加按钮
        insertAnnex() {
            if (this.btnRole.indexOf('136') != -1) {
                return (
                    <div style="width:30">
                        <el-button type="primary" size="small" on-click={() => this.clickInsertAnnex()}>添加</el-button>
                        <el-button type="primary" size="small" on-click={() => this.clickInsertAnnexExcel()}>批量添加</el-button>
                    </div>
                )
            }

        },
        clickInsert() {
            this.fileList = []
            this.insertdialog = true
        },
        clickInsertAnnex() {
            this.insertAnnexDialog = true
        },
        clickInsertAnnexExcel() {
            this.importExcelDialog = true
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
        handleChange(file, fileList) {
            this.fileList = fileList;
        },
        uploadFile(file) {
            this.insertFormData.append("file", file.file);
        },
        // 点击选取文件前清空文件
        clearFileList() {
            this.fileList = []
        },
        // 点击立即创建上传文件
        uploadFiles() {
            let insertFormData = new FormData();
            if (this.insertForm.name == "" || this.insertForm.name == null) {
                this.$message.warning("请输入文件名称");
            } else if (this.insertForm.type == "" || this.insertForm.type == null) {
                this.$message.warning("请选择文件类型");
            } else if (this.fileList[0] == null) {
                this.$message.warning("请选择要上传的资料");
            } else {
                let deviceDatas = JSON.parse(sessionStorage.getItem('deviceUpdate'))
                let deviceData = []
                if (deviceDatas.length == 1) {
                    deviceData = deviceDatas[0]
                } else {
                    deviceData = deviceDatas
                }
                let qz = ""
                debugger
                if (this.deviceinfoData.ejfl != null && this.deviceinfoData.ejfl != "") {
                    for (var i = 0; i < this.deviceTypeData.length; i++) {
                        if (this.deviceinfoData.ejfl == this.deviceTypeData[i].id) {
                            qz = this.deviceTypeData[i].glbhqz
                        }
                    }
                }
                let uuid = deviceData.sbxh + "_" + deviceData.sccj + "_" + qz
                insertFormData.append("userId", JSON.parse(localStorage.getItem("user")).userId);
                insertFormData.append("file", this.fileList[0].raw);
                insertFormData.append("name", this.insertForm.name);
                insertFormData.append("remark", this.insertForm.remark == undefined ? "" : this.insertForm.remark);
                insertFormData.append("type", this.insertForm.type);
                insertFormData.append("deviceid", deviceData.id);
                insertFormData.append("uuid", uuid);
                console.log(this.insertForm.remark)
                uploadAttachments(insertFormData).then(datas => {
                    let { data, status, message } = datas
                    if (status == 200) {
                        this.getDeviceDoc();
                        this.insertdialog = false
                        this.insertForm = []
                        this.fileList = []
                        this.$message.success("上传成功")
                    }
                })
            }


        },
        // 删除资料
        deleteDeviceDoc(row) {
            this.$confirm("此操作将彻底删除" + row.name + "文件,是否继续?", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var userinfo = JSON.parse(localStorage.getItem("user"))

                let _params = {
                    id: row.id,
                    userId: userinfo.userId
                }
                deleteById(_params).then(datas => {
                    console.log(datas)
                    let { message, status } = datas
                    if (status == 200) {
                        this.$message({ message: '删除成功', type: 'success' });
                        this.getDeviceDoc();
                    } else {
                        this.$message({ message: '删除失败', type: 'error' });
                    }
                })
            })
        },
        //点击编辑
        updateDocBtn(row) {
            this.updateDocData = row
            this.updateDocdialog = true
        },
        // 点击修改
        updateDoc() {
            if (this.updateDocData.name == "" || this.updateDocData.name == null) {
                this.$message.warning("请输入文件名称");
            } else if (this.updateDocData.type == "" || this.updateDocData.type == null) {
                this.$message.warning("请选择文件类型");
            } else {
                updateById(this.updateDocData).then(datas => {
                    let { status, data, message } = datas
                    if (status == 200) {
                        this.$message.success("修改成功");
                        this.getDeviceDoc();
                        this.updateDocdialog = false
                    }
                })
            }
        },
        // 下载
        downloading(row) {
            this.downloadUtil.downloadFile(row.path, row.name);
        },
        // 在线预览
        onlineView(row) {

            if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
                this.previewTitle = "图片预览"
            } else {
                this.previewTitle = "文件预览"
            }
            this.docxdialog = true
            this.$nextTick(() => {
                this.$refs.filePreview.showView(row.path)
            })

        },
        // 格式化时间显示到日期
        formateTime(row) {
            let nowData = new Date(row.createTime)
            let year = nowData.getFullYear();
            let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
            let date = nowData.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${date}`;
        },
        // 去维保页面
        toWeiBao() {
            this.$router.push({
                path: "maintenance",
            });
        },
        // 去报废页面
        toBaoFei() {
            this.$router.push({
                path: "scrap",
            });
        },
        // 去检定页面
        toCheck() {
            this.$router.push({
                path: "verification",
            });
        },
        // 点击保存并返回
        clickComitAndBack() {
            this.clickComit();
            this.reload = true //设置返回是否刷新判断
            setTimeout(() => {
                this.$router.push({
                    path: "DeviceInfo",
                });
            }, 2000)
        },
        // 查找设备附件
        selectDeviceAnnex() {
            let deviceUpdateDatas = JSON.parse(sessionStorage.getItem('deviceUpdate'));
            let deviceId
            if (deviceUpdateDatas.length == 1) {
                deviceId = deviceUpdateDatas[0].id
            } else {
                deviceId = deviceUpdateDatas.id
            }
            let _params = {
                deviceId: deviceId
            }
            selectAnnex(_params).then(datas => {
                let { data, status, message } = datas
                if (status == 200) {
                    this.annexData = data
                    this.annexNum = data.length
                }
            })
        },
        // 添加附件弹窗点击取消
        exitInsert() {
            this.insertAnnexDialog = false;
            this.annexForm = []
        },
        // 点击添加附件弹窗的添加按钮
        insertAnnexs() {
            let insertFormData = new FormData();
            let deviceUpdateDatas = JSON.parse(sessionStorage.getItem('deviceUpdate'));
            if (deviceUpdateDatas.length == 1) {
                insertFormData.append("pid", deviceUpdateDatas[0].id)
            } else {
                insertFormData.append("pid", deviceUpdateDatas.id)
            }
            insertFormData.append("sydw", deviceUpdateDatas.sydw)
            console.log(deviceUpdateDatas);
            insertFormData.append("zcmc", this.annexForm.zcmc)
            insertFormData.append("ccbh", this.annexForm.ccbh)
            // insertFormData.append("sl", this.annexForm.sl)
            // insertFormData.append("dw", this.annexForm.dw)
            insertFormData.append("cgrq", this.annexForm.cgrq)
            insertFormData.append("jdlx", this.annexForm.jdlx)
            insertFormData.append("jdzq", this.annexForm.jdzq)
            insertFormData.append("clfw", this.annexForm.clfw)
            insertFormData.append("cljd", this.annexForm.cljd)
            insertFormData.append("bz", this.annexForm.bz = "undefined" ? "" : this.annexForm.bz)
            insertFormData.append("userId", JSON.parse(localStorage.getItem("user")).userId)
            insertFormData.append("glbhs", this.formLabel["glbh"])
            console.log(insertFormData);
            debugger
            insertAnnex(insertFormData).then(datas => {
                let { data, status, message } = datas
                if (status == 200) {
                    this.$message.success("添加成功");
                    this.selectDeviceAnnex();
                    this.exitInsert();
                }
            })
        },
        // 点击删除附件
        deleteDeviceAnnex(row) {
            console.log(row)
            this.$confirm("此操作将彻底删除" + row.zcmc + "附件,是否继续?", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let _params = {
                    id: row.id
                }
                deleteAnnex(_params).then(datas => {
                    let { data, status, message } = datas
                    if (status == 200) {
                        this.$message.success("删除成功");
                        this.selectDeviceAnnex();
                    }
                })
            })
        },
        // 点击附件编辑按钮
        clickAnnexUpdate(row) {
            this.annexUpdateForm = row
            this.updateAnnexDialog = true
        },
        // 点击确定编辑附件
        updateAnnexComit() {
            let insertFormData = new FormData();
            insertFormData.append("id", this.annexUpdateForm.id)
            insertFormData.append("zcmc", this.annexUpdateForm.zcmc)
            insertFormData.append("ccbh", this.annexUpdateForm.ccbh)
            // insertFormData.append("sl", this.annexUpdateForm.sl)
            // insertFormData.append("dw", this.annexUpdateForm.dw)
            insertFormData.append("cgrq", this.annexUpdateForm.cgrq)
            insertFormData.append("jdlx", this.annexUpdateForm.jdlx)
            insertFormData.append("jdzq", this.annexUpdateForm.jdzq)
            insertFormData.append("clfw", this.annexUpdateForm.clfw)
            insertFormData.append("cljd", this.annexUpdateForm.cljd)
            insertFormData.append("bz", this.annexUpdateForm.bz)
            insertFormData.append("userId", JSON.parse(localStorage.getItem("user")).userId)

            updateAnnex(insertFormData).then(datas => {
                let { data, status, message } = datas
                if (status == 200) {
                    this.$message.success("修改成功");
                    this.selectDeviceAnnex();
                    this.updateAnnexDialog = false

                }
            })
        },
        beforeRemoveExcel(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        handleRemoveExcel(file, fileList) {
            console.log(file, fileList);
        },
        handlePreviewExcel(file) {
            console.log(file);
        },
        handleChangeExcel(file, fileList) {
            this.file = file
            this.fileList = fileList;
            this.uploadBool = false
            this.fileTemp = file.raw
            let reader = new FileReader();

            // 判断上传文件格式
            if (this.fileTemp) {
                // if ((this.fileTemp.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || (this.fileTemp.type == 'application/vnd.ms-excel')) {
                this.importfxx(this.fileTemp)
                // } else {
                //     this.$message({
                //         type: 'warning',
                //         message: '附件格式错误，请删除后重新上传！'
                //     })
                // }
            }

        },
        uploadFile(file) {
            // this.insertFormData.append("file", file.file);
        },
        handleExceedExcel(files, fileList) {
            this.$message.warning(`当前限制选择 1个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeUploadExcel(file) {
            // const isPdf = file.type === 'application/pdf';
            // if (!isPdf) {
            // 	this.$message.error('仅支持 pdf 格式!');
            // }
            // return isPdf
            this.uploadBool = true
        },
        closeExcelDialog() {
            this.fileList = []
        },
        download() {
            window.open(getBase() + '/deviceinfo/downloadTemplateFile?fileName=deviceAnnex.xlsx')
        },
        importfxx(obj) {
            let _this = this;
            // 通过DOM取文件数据
            this.file = obj
            var rABS = false; //是否将文件读取为二进制字符串
            var f = this.file;
            var reader = new FileReader();
            FileReader.prototype.readAsBinaryString = function (f) {
                var binary = "";
                var rABS = false; //是否将文件读取为二进制字符串
                var pt = this;
                var wb; //读取完成的数据
                var outdata;
                var reader = new FileReader();
                reader.onload = function (e) {
                    var bytes = new Uint8Array(reader.result);
                    console.log(reader.result)
                    var length = bytes.byteLength;
                    for (var i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    var XLSX = require('xlsx');
                    if (rABS) {
                        wb = XLSX.read(btoa(fixdata(binary)), { //手动转化
                            type: 'base64'
                        });
                    } else {
                        wb = XLSX.read(binary, {
                            type: 'binary'
                        });
                    }
                    const worksheet = wb.Sheets[wb.SheetNames[0]];
                    outdata = XLSX.utils.sheet_to_json(worksheet, { header: 1 });//outdata就是读取excel内容之后输出的东西
                    this.da = [...outdata]
                    let arr = []
                    let arrlist = []
                    _this.deviceAnnexList = []
                    this.da.map((v, index) => {
                        if (index > 1) {
                            arr = []
                            // if(v[1]==null){
                            //     return
                            // }else{
                            for (var i = 0; i < outdata[1].length; i++) {
                                if (v.length > 0) {
                                    arr.push(v[i] != null ? v[i] : "")
                                } else {
                                    return
                                }
                            }
                            // }
                            _this.deviceAnnexList.push(arr)
                        }

                    })
                    // _this.deviceinfoList=arrlist
                    console.log(_this.deviceAnnexList)
                    //return arr
                    // 把读取的excel表格中的内容放进tableData2中(这里要改成自己的表的名字)
                    // _this.tableData2 = _this.tableData2.concat(arr)
                }
                reader.readAsArrayBuffer(f);

            }
            if (rABS) {
                reader.readAsArrayBuffer(f);
            } else {
                reader.readAsBinaryString(f);
            }

        },
        clickUpload() {
            if (this.fileList.length == 0) {
                this.$message({
                    message: "请选择文件",
                    type: 'warning'
                })
            } else if (this.deviceAnnexList.length == 0) {
                this.$message({
                    message: "请勿上传空文件",
                    type: 'warning'
                })
            } else {
                let deviceinfos = [];
                this.loading = true
                this.loadingUtil.showLoading("正在上传中，请稍后……")
                for (var i = 0; i < this.deviceAnnexList.length; i++) {
                    deviceinfos.push({
                        zcmc: this.deviceAnnexList[i][1],
                        ccbh: this.deviceAnnexList[i][3],
                        cgrq: this.formateExceldate(this.deviceAnnexList[i][4]),
                        clfw: this.deviceAnnexList[i][5],
                        cljd: this.deviceAnnexList[i][6],
                        jdlx: this.formateExcelJdlx(this.deviceAnnexList[i][7]),
                        jdzq: this.deviceAnnexList[i][8],
                        // jdzs: this.deviceAnnexList[i][9],
                        // jddw: this.deviceAnnexList[i][10],
                        // jdrq: this.formateExceldate(this.deviceAnnexList[i][11]),
                        bz: this.deviceAnnexList[i][9],
                        sydw: this.deviceinfoData.sydw
                    })
                }
                debugger
                let _params = {
                    parameter: JSON.stringify(deviceinfos),
                    userId: JSON.parse(localStorage.getItem("user")).userId,
                    deviceGlbh: this.deviceinfoData.glbh,
                    pid: this.deviceinfoData.id
                }
                insertAnnexsExcel(_params).then(resultData => {
                    let { data, status, message } = resultData
                    if (status == 200) {
                        this.loadingUtil.hideLoading()
                        this.deviceAnnexList = []
                        this.importExcelDialog = false
                        this.fileList = []
                        this.$message({
                            message: "导入成功",
                            type: 'success'
                        })
                        this.selectDeviceAnnex();
                    } else if (status == 400) {
                        this.$message({
                            message: message,
                            type: 'warning'
                        })
                        this.loadingUtil.hideLoading()
                    } else {
                        this.$message({
                            message: message,
                            type: 'error'
                        })
                        this.loadingUtil.hideLoading()
                    }
                })
            }
        },
        // 格式化日期
        formateExceldate(dates) {
            let date1 = ""
            const newDate = dates
            if (newDate != null && newDate != "") {
                if (typeof (newDate) == 'string') {
                    let dt = new Date(newDate)
                    date1 = dt.getFullYear() + "-" + (dt.getMonth() + 1).toString().padStart(2, '0') + "-" + dt.getDate().toString().padStart(2, '0')
                } else {
                    let dt = new Date((newDate - 25569) * 24 * 60 * 60 * 1000)
                    let year = dt.getFullYear();
                    let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                    let date = dt.getDate().toString().padStart(2, '0');
                    let hour = dt.getHours().toString().padStart(2, '0');
                    let minute = dt.getMinutes().toString().padStart(2, '0');
                    let second = dt.getSeconds().toString().padStart(2, '0');
                    date1 = dt.getFullYear() + "-" + (dt.getMonth() + 1).toString().padStart(2, '0') + "-" + dt.getDate().toString().padStart(2, '0')

                }
            }
            return date1;
        },
        // 格式化检定类型
        formateExcelJdlx(jdlxs) {
            let jdlx = 0
            if (jdlxs == "检定") {
                jdlx = 0;
            }
            else if (jdlxs == "校准") {
                jdlx = 2;
            }
            else if (jdlxs == "设备核查") {
                jdlx = 1;
            }
            else if (jdlxs == "不检定/校准") {
                jdlx = 3;
            }
            return jdlx
        },
        clickAnnexDetail(row) {
            this.annexDetailDialog = true;
            this.deviceAnnexId = row.id;
            this.$nextTick(() => {
                this.$refs.annexDetailShow.getAnnexDetail()
            })

        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.reload == true) {
            if (to.path == "/DeviceInfo") {
                to.meta.keepAlive = false
                next()
            } else {
                next()
            }
        } else {
            if (to.path == "/DeviceInfo") {
                to.meta.keepAlive = true
                next()
            } else {
                next()
            }
        }
        next()
    },
    created() {
        this.getSelectData();
        this.onloadEjflSelect();
        this.getFormAddLabel();
        this.getDeviceDoc();
        this.selectCompany();
        this.selectDeviceAnnex();
    },
    watch: {

    },

}
</script>
<style scoped>
.btn {
    float: left;
}

.input {
    width: 90%;
}

.el-form-item {
    margin-bottom: 5px;
}
</style>
<style>
.el-input__inner {
    height: 32px !important;
    text-align: left !important;
}

.el-collapse-item__header {
    margin-left: 10px;
    background-color: #cecece !important;
    height: 30px;
    flex: 1 0 auto;
    order: -1;
}

.collapse-title {
    flex: 1 0 90%;
    order: 1;
}

.upload-demo {
    text-align: left !important;
}
</style>
<style lang="less" scoped>
.docWrap {
    // 指定样式宽度
    width: 900px;
    overflow-x: auto;
}
</style>
<style>
.el-form-item__error {
    top: 80% !important;
    left: 5% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/device/deviceinfoUpdate.vue